(function () {
  if (window.HVWish) return;
  var KEY = 'hv_wishlist';
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hv:wishlist'));
  }
  var api = {
    list: read,
    has: function (h) { return read().indexOf(h) > -1; },
    toggle: function (h) {
      var a = read();
      var i = a.indexOf(h);
      if (i > -1) { a.splice(i, 1); } else { a.push(h); }
      write(a);
    },
    sync: function () {
      var n = read().length;
      document.querySelectorAll('[data-hv-wish]').forEach(function (b) {
        var on = api.has(b.getAttribute('data-hv-wish'));
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-hv-wish-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = !(n > 0);
      });
    }
  };
  window.HVWish = api;

  function addToCart(btn) {
    var id = Number(btn.getAttribute('data-hv-add'));
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var ids = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { id: id, quantity: 1 };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hv-card', productVariantId: id, cartData: res });
        }
        if (cart && cart.renderContents) {
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { btn.classList.add('is-error'); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-hv-wish]');
    if (w) { e.preventDefault(); api.toggle(w.getAttribute('data-hv-wish')); return; }
    var b = e.target.closest && e.target.closest('[data-hv-add]');
    if (b && !b.disabled) { e.preventDefault(); addToCart(b); }
  });
  document.addEventListener('hv:wishlist', api.sync);
  document.addEventListener('DOMContentLoaded', api.sync);
  document.addEventListener('shopify:section:load', api.sync);
})();
